import {deleteCookie, setCookie} from '@github-ui/cookies'
import {useAnalytics} from '@github-ui/use-analytics'
import {useCallback} from 'react'

import {
  HIDDEN_SECTIONS_COOKIE_NAME,
  SECTION_ORDER_COOKIE_NAME,
} from '@github-ui/shared-dashboard-surface/constants/cookies'
import {persistPullsPreferences} from '@github-ui/shared-dashboard-surface/helpers/pulls-preferences-api'

const COOKIE_EXPIRY_MS = 100 * 24 * 60 * 60 * 1000 // 100 days

export interface SectionPreferences {
  order: string[]
  hidden: string[]
}

function writePreferenceCookie(name: string, values: string[]) {
  if (values.length === 0) {
    deleteCookie(name)
    return
  }

  const expireTime = new Date(Date.now() + COOKIE_EXPIRY_MS).toUTCString()
  setCookie(name, values.join(','), expireTime)
}

/** Persists the user's inbox section preferences (order and hidden ids) via client cookies. */
export function useUpdateSectionPreferences() {
  const {sendAnalyticsEvent} = useAnalytics()

  const saveSectionPreferences = useCallback(
    ({order, hidden}: SectionPreferences) => {
      sendAnalyticsEvent('pull-requests.click', 'CUSTOMIZE_SECTIONS_SAVE', {
        section_count: order.length.toString(),
        hidden_count: hidden.length.toString(),
      })

      writePreferenceCookie(SECTION_ORDER_COOKIE_NAME, order)
      writePreferenceCookie(HIDDEN_SECTIONS_COOKIE_NAME, hidden)
      persistPullsPreferences({section_order: order, hidden_sections: hidden})
    },
    [sendAnalyticsEvent],
  )

  return {saveSectionPreferences}
}
